import List from "@/components/list";
import vue from "@/main";
import { tableBaseProps } from '@/utils/common.js';

const Table = args => {
  const { listeners } = args;
  const { isOnline, isAttachment, onlineLearn, status } = args.props
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const editRemark = listeners["editRemark"] || function () { };
  const viewAuditDetail = listeners["viewAuditDetail"] || function () { };

  // 删除报名
  function deleteEnroll(enroll) {
    vue.$emit("deleteEnroll", enroll);
  }

  // 送审
  function sendAudit(enroll) {
    vue.$emit("sendAudit", enroll.uuid);
  }

  // 取消送审
  function cancelSendAudit(enroll) {
    vue.$emit("cancelSendAudit", enroll.uuid);
  }
  // 查看审核详情
  function uploadFile(enroll) {
    vue.$emit("uploadFile", enroll);
  }
  //附件下载
  function handleDownloadFile(enroll) {
    if (enroll.attachment) {
      vue.$emit("downloadUserFile", enroll);
    }
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;
    const dealConf = [];
    if (status < 4) {
      dealConf.push([
        enroll.enrollStatus === 0 || enroll.enrollStatus === 3
          ? "icon-remove"
          : "icon-remove-disable",
        "移除",
        enroll.enrollStatus === 0 || enroll.enrollStatus === 3
          ? () => {
            deleteEnroll(enroll);
          }
          : () => { },
        "enroll:deleteEnroll"
      ]);
    }
    if (isAttachment == 1) {
      dealConf.push([
        enroll.enrollStatus === 0 || enroll.enrollStatus === 3
          ? "icon-upload-file"
          : "icon-upload-file-disable",
        "上传附件",
        enroll.enrollStatus === 0 || enroll.enrollStatus === 3
          ? () => {
            uploadFile(enroll);
          }
          : () => { },
        "enroll:upload"
      ]);
    }
    const showSendAudit = isOnline != 1 || (isOnline == 1 && (status >= 1 && status < 4))

    if (enroll.enrollStatus !== 0 && enroll.enrollStatus !== 3) {
      dealConf.push([
        enroll.enrollStatus === 2
          ? "icon-cancel-audit-disable"
          : "icon-cancel-audit",
        "取消送审",
        enroll.enrollStatus === 2
          ? () => { }
          : () => {
            cancelSendAudit(enroll);
          },
        "enroll:cancelAudit"
      ]);
    } 
    if (showSendAudit &&  enroll.enrollStatus == 0 || enroll.enrollStatus == 3) {
      dealConf.push([
        !enroll.attachment && isAttachment == 1
          ? "icon-send-audit-disable"
          : "icon-send-audit",
        "送审",
        !enroll.attachment && isAttachment == 1
          ? () => { }
          : () => {
            sendAudit(enroll);
          },
        "enroll:sendAudit"
      ]);
    }
    dealConf.push([
      enroll.enrollStatus !== 0
        ? "icon-audit-detail"
        : "icon-audit-detail-disable",
      "审核详情",
      enroll.enrollStatus !== 0
        ? () => viewAuditDetail(enroll)
        : () => { },
      "enroll:auditInfo"
    ]);


    !(isOnline == 1) && dealConf.push(['iconfont ic_a-banjibeizhu-moren2x iconfont-adapt', '报名备注', () => editRemark(enroll, true), 'enroll:updateRemarks'])
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const Remarks = ({ props: { vo } }) => {
    const { row } = vo
    const { remarks } = row;
    if (!remarks) {
      return <div>--</div>
    }
    return (
      <div class="base-hover-char ellipsis--l2" onClick={() => editRemark(row)}>
        {remarks}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    tableBaseProps("姓名", "userName", "100"),
    tableBaseProps("工作单位", "deptName", "m120"),
    tableBaseProps("单位及职务", "unitPosition", "m150"),
    tableBaseProps("浙政钉绑定状态", "zzdBindStatusStr", "m100"),
    tableBaseProps("报名情况", "enrollStatusName", "120"),
    tableBaseProps("在线课件学习情况", "onlineLearnStatusStr", "140"),
    tableBaseProps("结业状态", "graduationStatusName", "120"),
    tableBaseProps("培训天数", "trainDaysName", "120"),
    {
      label: "报名附件",
      minWidth: "140",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          // v-permission="work:download"
          onClick={() => handleDownloadFile(vo.row)}
        >
          {vo.row.attachmentName}
        </el-button>
      )
    },
    tableBaseProps("报名时间", "createDate", "160"),
    {
      label: "操作",
      fixed: "right",
      width: "130",
      render: vo => <Deal vo={vo} />
    }
  ];
  if (isAttachment == 0) {
    AccountTableConfig.splice(8, 1);
  }
  if (onlineLearn != 1) {
    AccountTableConfig.splice(6, 1);
  }
  if (isOnline == 1) {
    AccountTableConfig.splice(6, 0, tableBaseProps("学习进度", "learningRate", "140"));
  } else {
    AccountTableConfig.splice(AccountTableConfig.length - 1, 0, {
      ...tableBaseProps("报名备注", "remarks", "150"),
      render: (vo) => <Remarks vo={vo} />,
    })
  }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
